import React from 'react';
import { useQuery } from 'react-query';
import { GetCommunityStrategies } from 'services/apiServices';
import { Errors, TCommunityStrategiesResult } from 'types/ApiServicesTypes';
import { debounce } from 'lodash';

const WAIT_INTERVAL = 300;

export default function useGetCommunityStrategies(page = 1, pageSize = 10) {
  const [currentPage, setCurrentPage] = React.useState(page);

  const objQuery = useQuery<TCommunityStrategiesResult, Errors>(
    ['GetCommunityStrategies', currentPage, pageSize],
    () => GetCommunityStrategies(currentPage, pageSize),
  );

  const { refetch } = objQuery;

  const debouncedRefetch = React.useMemo(() => {
    return debounce(refetch, WAIT_INTERVAL);
  }, [refetch]);

  // If the page changes, refetch the data
  React.useEffect(() => {
    void refetch();
  }, [currentPage, refetch]);

  return {
    ...objQuery,
    currentPage,
    setCurrentPage,
  };
} 